export const DEFAULT_COPY_MODAL_PLAN_UPDATE = {
  title: 'Você precisa ser aluno premium para acessar esse conteúdo.',
  description:
    'Por menos de R$1,40 por dia, você pode ter acesso ilimitado a tudo que o Explicaê oferece.'
};
